module.exports = __webpack_public_path__ + "static/franklin-split-085f5b4a421f0b39d03848303b6dcaae.png";